module.exports = __webpack_public_path__ + "img/42.828daf56.svg";